import { all, call, put, takeLatest } from "redux-saga/effects";
import queryString from "query-string";
import { normalize, schema } from "normalizr";
import { getErrorMessage } from "utils/sagasErrorHandler";
import {
    getConfigs,
    getConfigsError,
    getConfigsSuccess,
    getConfig,
    getConfigError,
    getConfigSuccess,
    editConfig,
    validateConfig,
    createConfig,
    setConfigFormDialog,
    getConfigExamplesSuccess,
    extractKeySuccess,
    getConfigExamples,
    extractKey
} from "modules/PrimaryKey/services/PrimaryKey/actions";
import {
    getConfigsRequest,
    createConfigRequest,
    editConfigRequest,
    validateConfigRequest,
    getConfigExamplesRequest,
    extractKeyRequest
} from "modules/PrimaryKey/services/PrimaryKey/api";
import {toast} from "react-toastify";

const configsSchema = new schema.Entity("configs");
const configsListSchema = new schema.Array(configsSchema);

//Workers
function* handleRefreshList() {
    const { search } = window.location;
    yield put(getConfigs(queryString.parse(search)));
}

function* handleGetConfigs({ payload }) {
    try {
        const { count, configs } = yield call(getConfigsRequest, payload);
        const { result, entities } = normalize(configs, configsListSchema);
        yield put(getConfigsSuccess({
            configs: entities.configs,
            ids: result,
            count
        }));

    } catch (error) {
        yield put(getConfigsError());
        getErrorMessage(error);
    }
}

function* handleGetConfig({ payload }) {
    try {
        const { configs } = yield call(getConfigsRequest, payload);
        const config = configs.length > 0 ? configs[0] : null;
        yield put(getConfigSuccess({
            config: config,
        }));

    } catch (error) {
        yield put(getConfigError());
        getErrorMessage(error);
    }
}

function* handleGetConfigExamples({ payload }) {
    try {
        const { examples } = yield call(getConfigExamplesRequest, payload);
        yield put(getConfigExamplesSuccess({
            examples,
        }));

    } catch (error) {
        getErrorMessage(error);
    }
}

function* handleCreateConfig ({ payload }) {
    try {
        yield call(createConfigRequest, payload);

        yield put(setConfigFormDialog());
        yield call(toast.success, "The config has been successfully created");

        yield handleRefreshList();
    } catch (error) {
        getErrorMessage(error);
    }
}

function* handleEditConfig ({ payload }) {
    try {
        yield call(editConfigRequest, payload);

        yield put(setConfigFormDialog());
        yield call(toast.success, `The config with ID - ${payload.config.id} has been successfully edited`);

        yield handleRefreshList();
    } catch (error) {
        getErrorMessage(error);
    }
}

function* handleValidateConfig ({ payload }) {
    try {
        yield call(validateConfigRequest, payload);
        yield call(toast.success, `The config has been successfully validated without errors`);
    } catch (error) {
        getErrorMessage(error);
    }
}

function* handleExtractKey ({ payload }) {
    try {
        const response = yield call(extractKeyRequest, payload);
        yield put(extractKeySuccess({
            "extractedKeyResponse": JSON.stringify(response),
        }));

    } catch (error) {
        getErrorMessage(error);
    }
}

// Watchers
export function* configsSagas() {
    yield all([
        yield takeLatest(getConfig, handleGetConfig),
        yield takeLatest(getConfigs, handleGetConfigs),
        yield takeLatest(getConfigExamples, handleGetConfigExamples),
        yield takeLatest(createConfig, handleCreateConfig),
        yield takeLatest(editConfig, handleEditConfig),
        yield takeLatest(validateConfig, handleValidateConfig),
        yield takeLatest(extractKey, handleExtractKey)
    ]);
}
